"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsMenu = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../../theme/icons");
const UserSettingsMenu_styles_1 = require("./UserSettingsMenu.styles");
const UserSettingsMenu = ({ username, email, settingsLabel, logoutLabel, onLogoutClick, onSettingsClick, url, projectsLabel, }) => {
    const openDesignerPage = () => {
        const targetWindowName = "designerTab";
        const dashboardTab = window.open(url, targetWindowName);
        if (!dashboardTab || dashboardTab.closed) {
            window.open(url, "_blank");
        }
        else {
            dashboardTab.focus();
        }
    };
    return (react_1.default.createElement(UserSettingsMenu_styles_1.UserSettingsWrapper, null,
        react_1.default.createElement(UserSettingsMenu_styles_1.UserNameWrapper, null, username),
        react_1.default.createElement(UserSettingsMenu_styles_1.EmailWrapper, null, email),
        react_1.default.createElement(UserSettingsMenu_styles_1.HorizontalLine, null),
        react_1.default.createElement(UserSettingsMenu_styles_1.ItemWrapper, { onClick: onSettingsClick },
            react_1.default.createElement(UserSettingsMenu_styles_1.IconWrapper, null,
                react_1.default.createElement(icons_1.Settings, null)),
            settingsLabel),
        url && projectsLabel && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(UserSettingsMenu_styles_1.ItemWrapper, { onClick: openDesignerPage },
                react_1.default.createElement(UserSettingsMenu_styles_1.IconWrapper, null,
                    react_1.default.createElement(icons_1.ListAlt, null)),
                projectsLabel),
            react_1.default.createElement(UserSettingsMenu_styles_1.HorizontalLine2, null))),
        react_1.default.createElement(UserSettingsMenu_styles_1.ItemWrapper, { onClick: onLogoutClick },
            react_1.default.createElement(UserSettingsMenu_styles_1.IconWrapper, null,
                react_1.default.createElement(icons_1.Logout, null)),
            logoutLabel)));
};
exports.UserSettingsMenu = UserSettingsMenu;
//# sourceMappingURL=UserSettingsMenu.js.map